import { Component, ViewChild, ElementRef,HostListener, AfterViewInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext,WebResponesContext } from '../../../../model/common';
import{ NavController, ActionSheetController,AlertController,Events,IonTabs,MenuController,ModalController,Platform,PopoverController} from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { NativeService } from 'src/service/native.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { Device } from '@ionic-native/device/ngx';
import { EmitserviceService } from 'src/service/emitservice.service';
import {WxjssdkService} from 'src/service/wxjssdk.service';
import {PublicselectionPage} from '../../../publicselection/publicselection.page';
import {SelectionpagePage} from '../../../selectionpage/selectionpage.page';
import { ListofActivitiesPage } from '../../listof-activities/listof-activities.page'
declare var app;
@Component({
  selector: 'app-a2-scan-code-sales',
  templateUrl: './a2-scan-code-sales.component.html',
  styleUrls: ['./a2-scan-code-sales.component.scss']
})
export class A2ScanCodeSalesComponent extends GridBaseCase implements AfterViewInit{

  @ViewChild('qrcode') qrcode: ElementRef;
  FK_TBActivity_ID: any = null;
  DisabledSubmit: boolean = false;
  isFormActivity:boolean = true;
  selectVal:any = null;
  activityName:any="请选择活动";
  activityID:string=null;
  milkActivity:any = null;
  tempGridList:Array<any>=new Array<any>();//礼品/样品列表
  tempGridgifList:Array<any>=new Array<any>();// 样品列表
  lpArrayList:Array<any>=[];//礼品列表
  ischeckAll:boolean=false;//是否返回权限
  ischeckAllg:boolean=false; //是否 样品返回全选
  
  _memberID:string=null;
  VipData:{};//会员信息
  arrayDataVip=[];//会员信息
  isHaveVip:boolean=false;
  stageShow:boolean = true; //赠品按钮显示隐藏
  // logisticsCode:Array<string>=new Array<string>();//缓存罐码
  GridArrayDatashow:boolean = false;
  activityListArray:Array<any> = new Array<any>();//活动名称列表
  isShow:boolean=true;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal,
    public native: NativeService,
    public alertCtrl:AlertController,
    public modalCtrl:ModalController,
    public menuCtrl:MenuController,
    public actionSheetCtrl:ActionSheetController,
    public popoverCtrl:PopoverController,
    private alertController: AlertController,
    private barcode: BarcodeScanner,
    private device:Device,
    private emitService:EmitserviceService,
    private weixin:WxjssdkService
  ) { super(); 
    this.baseService.FixedSubmitBtn.configName = "ScanCodeSales";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.text = "确认下单";
    this.baseService.FixedSubmitBtn.type = 2;
    this.base.GridListCount=0;
    this.base.GridGiftCount=0;
    this.base.GridGiftNumber=0;
    this.baseService.FixedSubmitBtn["GridListCount"] = this.base.GridListCount;
    // this.modalEvent()
    const _id = this.activaRouter.snapshot.paramMap.get('id');
    if(_id && _id.split("&")[0]){
      this.FK_TBActivity_ID = _id.split("&")[0];
      this.isFormActivity = true;
      if(_id.split("&")[1]){
        this.milkActivity = _id.split("&")[1];
      }
    }
  }

  ngAfterViewInit(){
    this.BindActivityInfo();
    /**
     * milkActivity 奶卡活动入口进来
     * mmbActivity 妈妈班活动入口进来
     * 自动弹出选择扫码方式
     */
    if(this.milkActivity && (this.milkActivity == "milkActivity" || this.milkActivity == "mmbActivity")){
      this.qrCodeClick();
    }
  }
/**
 * 选择的活动名称
 * @param event 
 */
  changeSelectActive(event){
    const that =this;
    if (!event.detail.value) {
      this.activityID = null;
    } else {
      this.activityID = event.detail.value;
    }
    that.activityName = "";
    that.activityListArray.forEach(item=>{
      if(that.activityID == item.a_ID){
        that.activityName = item.a_Name;
      }
    })
    if(!that.activityName){
      that.activityName = "扫码销量";
    }
  }
  /**
   * 选择值
   * @param event 
   */q
  changeSelect(event) {
    let that = this;
    console.log(event.detail.value);
    if (event.detail.value == "无") {
      this.FK_TBActivity_ID = null;
    } else {
      this.FK_TBActivity_ID = event.detail.value;
    }
    that.selectVal = "";
    this.baseService.ListData.forEach(item=>{
      item.isCheck = false;
      if(that.FK_TBActivity_ID == item.id){
        item.isCheck = true;
        that.selectVal = item.text;
      }
    })
    if(!that.selectVal){
      that.selectVal = "扫码销量";
    }
  }
  /**
   * 数量改变事件
   * @param item 
   */
  onInput(item) {
    console.log(item);
    this.baseService.FixedSubmitBtn["GridListCount"] = this.base.GridListCount;
  }
  /**
   * 礼品/样品值变化
   * @param item 
   */
  onInputChanage(item,e){
    const that =this;
    console.log(e,"值的变化");
    let _value="";
    if(e.target.value.trim()){
      _value=e.target.value;
    }else{
      _value="0";
    }
      item.Num=that.com.GetNumber(_value);
    let temoCount:number = 0;
    that.tempGridList.forEach(t=>{
      temoCount+=t.Num;
    });
    e.target.value=item.Num;
    that.base.GridGiftCount = temoCount;
  }
  /**
   * 
   * @param PageNumber 
   * 样品选择
   */
  onInputChanage1(item,e){
    const that =this;
    console.log(e,"值的变化");
    let _value="";
    if(e.target.value.trim()){
      _value=e.target.value;
    }else{
      _value="0";
    }
      item.Num=that.com.GetNumber(_value);
    let temoCount:number = 0;
    that.tempGridgifList.forEach(t=>{
      temoCount+=t.Num;
    });
    e.target.value=item.Num;
    that.base.GridGiftNumber = temoCount;
  }
  LoadData(PageNumber) {
    let that = this;
    let temp:Array<any> = [{"id":0,"text":"扫码销量",isCheck:true},{"id":1,"text":"提报自然销量",isCheck:false},{"id":2,"text":"消费者退货",isCheck:false},{"id":3,"text":"扫码入库",isCheck:false}];
         that.baseService.ListData=temp;
        that.FK_TBActivity_ID=that.baseService.ListData[0].id;
         that.selectVal = "扫码销量";
    //#region 之前逻辑
          // that.PageNumber = PageNumber;
          // const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
          // let body = new WebParameterContext();
          // body.ConfigName = "TBActivityApp";
          // body.OpType = "query";
          // body.ConfigType = "view";
          // body.RowsPerPage = app.RowsPerPage;
          // body.PageNumber = PageNumber;
          // body.Client.PageName = PageName;
          // body.Client.ApiType = "Element";
          // body.Client.Name = that.element.name;
          // body.Client.ClientType = 2;
          // if (that.platform.is("android")) {
          //   body.Client.ClientType = 0;
          // } else if (that.platform.is("ios")) {
          //   body.Client.ClientType = 1;
          // }

          // //TODO: 判断是否鲜入为主活动
          // let _body = {
          //   // "flag":1
          // };
          // if(!that.milkActivity || that.milkActivity != "milkActivity"){
          //   _body["type"]=1;//添加type，筛选结果不显示鲜入为主活动
          // }
          // body.RequestBody = JSON.stringify(_body);
          // that.http.post(app.DEFAULTURL, body).then(data => {
          //   /****判断是否第一页end****/
          //   if (data.ResponseMessage.Success) {
          //     console.log(data.Status.Datas,"扫码销量");
          //     that.baseService.ListData = data.Status.Datas;
          //       that.baseService.ListData.forEach(item=>{
          //         item.isCheck = false;
          //         if(that.FK_TBActivity_ID == item.a_ID){
          //           item.isCheck = true;
          //           that.selectVal = item.a_Name;
          //         }
          //       })
          //       if(!that.selectVal){
          //         that.selectVal = "扫码销量";
          //       }
          //   }
          // }).catch(error => {
          //   console.log(error);
          // })
    //#endregion
  }
    /**
   * 获取活动列表
   */
     BindActivityInfo(){
      const that =this;
      that.activityListArray=[];
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
      body.ConfigName = "GetActivityList";
      body.OpType = "query";
      body.ConfigType = "form";
      // body.RowsPerPage = app.RowsPerPage;
      body.PageNumber = 0;
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.Name = that.element.name;
      body.Client.ClientType = 0;
      body.RequestBody = JSON.stringify({"telPhone": ""})
      that.http.post(app.DEFAULTURL, body).then(data => {
        /****判断是否第一页end****/
        if (data.ResponseMessage.Success) {
         that.activityListArray=data.Status.Datas||[];
        } else {
          console.log(data.ResponseMessage.ErrorMessage,"拉去活动列表失败");
        }
      }).catch(error => {
      console.log(error,"拉去活动列表失败");
      });
    }
    async presentModaldifferences() {
      var that=this;
      // debugger;
      const modal = await this.modalCtrl.create({
        component: ListofActivitiesPage,
        cssClass: 'listof-activities',
        componentProps: {
          "type":"扫码销量",
          "activityListArrayList":that.activityListArray, 
          "activeID":that.activityID
        }
      });
        await modal.present();
      const { data } = await modal.onWillDismiss();
      console.log(data)
      if(data.seceltName){
        that.activityName = data.seceltName;
        that.activityID = data.FK_TBReasonsProductInventoryDifferences_ID;
      }
      console.log(data.cravingforRemk)
     console.log(data.FK_TBReasonsProductInventoryDifferences_ID)
    }
    // 清楚选择的活动
  cleashideModal(){
    const that=this;
    that.activityName ="请选择活动";
    that.activityID ="";
  }
  /**
   * 确认下单
   */
  EventClick() {
    const that = this;
    console.log("扫描销量");
    if (that.base.GridArrayData.length <= 0) {
      that.msg.Alert("请扫码添加产品");
      that.baseService.FixedSubmitBtn.isSubmitData = true;
      return;
    }
    if(that.base.GridArrayData.length>0 && that.tempGridList.length>0 ){
      if(that.base.GridArrayData.find(item=>item.newMemberType== "4")){
        that.msg.Alert("勾选礼品无效请重新勾选");
        return;
    }
  }
    
that.EventBeforeClick().then(res=>{
  that.msg.Confirm("确认下单吗？","取消","确定","",false).then(msgs=>{
    if(msgs){
      that.msg.Loading("数据请求中...").then(loads=>{
      res.Status.ConfigName="ProductPurchase";
            that.http.post(app.DEFAULTURL, res.Status).then(data => {
              that.baseService.FixedSubmitBtn.isSubmitData = true;
              that.DisabledSubmit = true;
              loads.dismiss();
              /****判断是否第一页end****/
              if (data.ResponseMessage.Success) {
                that.base.GridArrayData = new Array<any>();
                that.base.GridListCount = 0;
                console.log(data);
                that.msg.Alert("下单成功").then(dd=>{
                  that.com.goBack();
                })
                
              } else {
                that.msg.Alert(data.ResponseMessage.ErrorMessage);
              }
            }).catch(error => {
              that.baseService.FixedSubmitBtn.isSubmitData = true;
              loads.dismiss();
              that.DisabledSubmit = false;
              console.log(error);
              that.msg.Alert(error.ResponseMessage.ErrorMessage);
            });
        loads.present();
      })
    }
  })
}).catch(res=>{
  that.msg.Confirm("确认下单吗？","取消","确定","",false,true).then(res=>{
    if(res){
    }
  });
});
}
  /**
   * 请求数据之前
   */
  EventBeforeClick(): Promise<WebResponesContext>{
    const that=this;
    return new Promise<WebResponesContext>((resolve,reject)=>{
      let  respone:WebResponesContext=new WebResponesContext();
     
      let DataList: Array<any> = new Array<any>();
        let lpArray:Array<any>=new Array<any>();//礼品列表
       //#region 产品列表
        that.base.GridArrayData.forEach(item => {
          let array = {};
          array["a_FK_TBProductInformation_ID"] = item.id;
          array["a_Num"] = item.num;
          array["a_productCode"] = item.code;
          array["a_FK_TBActivity_ID"] = that.FK_TBActivity_ID;
          array["IntegralCodeDetailList"]=item.IntegralCodeDetailList;
          DataList.push(array);
        });
       //#endregion
           //#region  礼品
          that.tempGridList.forEach(p=>{
            let c:any={};
            c["id"]=p.id;
            c["Stock"]=p.Stock;
            c["Code"]=p.Code;
            c["Num"]=p.Num;
            lpArray.push(c);
          });
        //#endregion
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  body.ConfigName = "CheckProductPurchase";
  body.OpType = "add";
  body.ConfigType = "view";
  body.RowsPerPage = app.RowsPerPage;
  body.PageNumber = 0;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = that.element.name;
  body.Client.ClientType = 2;
  let _obj={"giftData":lpArray,"productData":DataList,"memberID":that._memberID,"a_FK_TBActivity_ID":that.activityID,"OrderEntry":"2"};
  body.RequestBody = JSON.stringify(_obj);
  respone.Status=body;
  respone.ResponseMessage.Success=true;
  respone.ResponseMessage.ErrorMessage="";
      that.msg.Loading("数据请求中...").then(loads=>{
        that.http.post(app.DEFAULTURL, body).then(data => {
          loads.dismiss();
          /****判断是否第一页end****/
          if (data.ResponseMessage.Success) {
            resolve(respone);
          } else {
            respone.ResponseMessage.Success=false;
            respone.ResponseMessage.ErrorMessage=data.ResponseMessage.ErrorMessage;
            reject(respone);
          }
        }).catch(error => {
          respone.ResponseMessage.Success=false;
          respone.ResponseMessage.ErrorMessage="系统异常请联系管理员";
          reject(respone);
        });
          loads.present();
      });
    });
  }

  qrCodeClick(){
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const id = that.activaRouter.snapshot.paramMap.get('id');

    that.presentAlertCheck(PageName);
  }

  async presentAlertCheck(PageName) {
    const that = this;
    let isplatform:boolean = false;
     if(that.platform.is("cordova")){
      if(that.platform.is("android")){
        if(that.device.version){
          if(that.device.version.toString().startsWith("4")){
            isplatform=true;
          }else if(that.device.version.toString().startsWith("3")){
            isplatform=true;
          }else if(that.device.version.toString().startsWith("2")){
            isplatform=true;
          }
        }
      }
     };
     if(that.com.IsWeixinBrowser){//如果是微信客户端调用微信
      isplatform=false;
     }
     if(isplatform){
      if(window.confirm("请选择扫码方式,【确定】表示扫码,【取消】表示手动输入")){
        that.scanQrcode(PageName);
       }else{
        var code= window.prompt("请输入产品罐码/箱码","");
        if(code){
          let _obj = {};
          _obj["Code"] = code;
          that.LoadDataBind(_obj);
        }else{
          that.msg.Alert("编码不能为空！");
        }
       }
     }else{
      const alert = await this.alertController.create({
        header: '系统提示',
        message:"请选择方式",
        mode:"ios",
        cssClass:"more-btn",
        buttons: [
          {
            text: "扫码识别",
            cssClass: 'btn-okay btn-width',
            handler: (Okay = "1") => {
              // console.log(Okay,"ok");
              // that.com.setHistoryUrl();
              that.scanQrcode(PageName);
              console.log("点击数据数据扫码识别")
              console.log(that.base.GridArrayData);
             
            }
          },
          {
            text: "手动输入",
            cssClass: 'btn-okay btn-width',
            handler: (Okay1 = "2") => {
              // console.log(Okay1,"ok1");
              that.presentAlertInput();
              console.log("点击数据数据手动输入")
              console.log(that.base.GridArrayData);
              
             
              // console.log(that.base.GridArrayData.stageName);
            }
          },
          {
            text: "取消",
            role: 'cancel',
            cssClass: 'secondary btn-cancel btn-width',
            handler: (cancel) => {
              console.log(cancel,"cancel");
            }
          }
        ]
      });
      await alert.present();
     }
  }


  async presentAlertInput() {
    const that = this;
    const alert = await this.alertController.create({
      header: '请输入产品罐码/箱码',
      mode:"ios",
      inputs: [
        {
          name: 'a_Code',
          type: 'text',
          label: '请输入产品罐码/箱码',
          value: '',
          min: 6
        }
      ],
      buttons: [
        
        {
          text: "取消",
          role: 'cancel',
          cssClass: 'secondary btn-cancel',
          handler: (cancel) => {
            //console.log(cancel,"cancel");
          }
        },
        {
          text: "确认",
          cssClass: 'btn-okay',
          handler: (Okay) => {
            //console.log(Okay,"ok");
            if (Okay && Okay["a_Code"]) {


              let _obj = {};
              _obj["Code"] = Okay["a_Code"];
              that.LoadDataBind(_obj);
            } else {
              that.msg.Alert("编码不能为空！");
            }

          }
        },
      ]
    });

    await alert.present();
  }
    /**
   * 扫码
   * @param PageName 
   */
  scanQrcode(PageName) {
    const that = this;

    if (that.platform.is('cordova')) {
      // that.com.setHistoryUrl();
      that.barcode.scan().then((scan) => {
        let sancanArray: Array<any> = new Array<any>();
        sancanArray = that.com.GetStorageKey("backurl") || [];
        sancanArray.splice(sancanArray.length - 1, 1);
        localStorage.setItem("backurl", JSON.stringify(sancanArray));
        if (PageName) {
          if (PageName == "ScanCodeSales") {
            let _obj = {};
            console.log(scan);
            if(scan.text){
              _obj["Code"] = scan.text;
              that.LoadDataBind(_obj);
            }
          }
        }
      }).catch(error => {
        that.msg.Show(error);
      });
    } else {
      if(that.com.IsWeixinBrowser){
        that.weixin.GetWxScanQRCode().then(data=>{
          console.log("存储的数据存储的数据")
          console.log(data);
          // alert("扫码销量");
          let _obj = {};
            _obj["Code"] = data.Status;
            console.log(JSON.stringify(_obj),"返回二维码编码");
            // alert(JSON.stringify(_obj));
            that.LoadDataBind(_obj);
        }).catch(err=>{
          that.msg.Show(err.ResponseMessage.ErrorMessage, "middle");
        });
      }else{
        that.msg.Show("暂不支持", "middle");
      }
    }
  }
  LoadDataBind(obj: any) {
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
        body.ConfigName = "ScanCodeXML";// "TBProductInformationXML";//产品名称
        body.OpType = "query";
        body.ConfigType = "view";
        body.RowsPerPage = app.RowsPerPage;
        body.PageNumber = 1;
        body.Client.PageName = PageName;
        body.Client.ApiType = "Element";
        body.Client.Name = "element";
        body.Client.ClientType = 2;
        body.SpecialParameter=2;
        if (that.platform.is("android")) {
          body.Client.ClientType = 0;
        } else if (that.platform.is("ios")) {
          body.Client.ClientType = 1;
        }
        body.RequestBody = JSON.stringify(obj);
    console.log(body,"请求接口");
    that.msg.Loading("数据请求中...").then(loads=>{
      that.http.post(app.DEFAULTURL, body).then(data => {
        // console.log("data数据数据888888");
        // console.log("data数据数据888888",data);
        // that.msg.Alert(JSON.stringify(data.Status));
        loads.dismiss();
        if (data.ResponseMessage.Success) {
          let isproduct: boolean = false;  
          if(that.base.GridArrayData.length>0){
            that.base.GridArrayData.forEach(t=>{
                  // if(t.code==data.Status.productCode){
                  //    isproduct = true;
                  // }
            console.log(t);
              if(t.IntegralCodeDetailList){
                t.IntegralCodeDetailList.forEach(g=>{
//                   if(g.LogisticsCode == obj.Code || g.BoxBarcode==obj.code){
//                     isproduct = true;
//                   }

                  if(obj.Code.indexOf(g.LogisticsCode)!=-1 || obj.Code.indexOf(g.BoxBarcode)!=-1){
                      isproduct = true;
                    }
                });
              }
            });
          }
          if (isproduct) {
            that.msg.Alert("已录入，请勿重复录入");
            return;
          } 
          if(data.Status.ResultCode === 3){
            console.log(data.Status.ResultMSG)
            that.msg.Confirm(`当前产品的扫描数量（${data.Status.IntegralCodeDetailList.length}听/罐）与实际箱规数量（${data.Status.boxCount}听/罐）不一致，是否按照实际箱规数量进行下单?`,"取消","确定").then(fit=>{
              if(fit){
                          let _data = {};
                          _data["id"] = data.Status.productId;
                          _data["name"] = data.Status.shortName  || data.Status.productname  ;
                          _data["num"] = data.Status.Count;
                          _data["code"] = data.Status.productCode;
                          _data["newMemberType"]=data.Status.newMemberType||"0";
                          _data["stageName"] = data.Status.stageName;
                          // _data["Code"]=obj.Code;
                          // if(data.Status.IntegralCodeDetailList){
                          //   data.Status.IntegralCodeDetailList.forEach(pro=>{
                          //     if(pro.LogisticsCode){
                          //       that.logisticsCode.push(pro.LogisticsCode);
                          //     }
                          //   });
                          // }
                          _data["IntegralCodeDetailList"] = data.Status.IntegralCodeDetailList;
                          let isproductnum: boolean = false;
                          that.base.GridArrayData.forEach(item => {
                            if (item.id == data.Status.productId) {
                              data.Status.IntegralCodeDetailList.forEach(items => {
                                item.IntegralCodeDetailList.push(items);
                              });
                              let coun1: number = item.num;
                              let count2: number = data.Status.Count;
                              let count3: number = coun1 + count2;
                              item.num = count3;
                              isproductnum = true;
                            }
          
                            
                          });
                          if (!isproductnum) {
                            that.base.GridArrayData.push(_data);
                          }
                          let sumNum: number = data.Status.Count;
                          that.base.GridListCount += sumNum;
                          console.log(that.base.GridArrayData,"处理完毕");

              }else{
                return;

              }
            });
          }else{
              let _data = {};
              _data["id"] = data.Status.productId;
              _data["name"] = data.Status.shortName  || data.Status.productname;
              _data["num"] = data.Status.Count;
              _data["code"] = data.Status.productCode;
              _data["newMemberType"]=data.Status.newMemberType||"0";
              _data["stageName"] = data.Status.stageName;
              // _data["Code"]=obj.Code;
              // if(data.Status.IntegralCodeDetailList){
              //   data.Status.IntegralCodeDetailList.forEach(pro=>{
              //     if(pro.LogisticsCode){
              //       that.logisticsCode.push(pro.LogisticsCode);
              //     }
              //   });
              // }
              _data["IntegralCodeDetailList"] = data.Status.IntegralCodeDetailList;
              let isproductnum: boolean = false;
              that.base.GridArrayData.forEach(item => {
                if (item.id == data.Status.productId) {
                  data.Status.IntegralCodeDetailList.forEach(items => {
                    item.IntegralCodeDetailList.push(items);
                  });
                  let coun1: number = item.num;
                  let count2: number = data.Status.Count;
                  let count3: number = coun1 + count2;
                  item.num = count3;
                  isproductnum = true;
                }

                
              });
              if (!isproductnum) {
                that.base.GridArrayData.push(_data);
              }
              let sumNum: number = data.Status.Count;
              that.base.GridListCount += sumNum;
              console.log(that.base.GridArrayData,"处理完毕");
          }
              

          // that.base.GridArrayData.forEach(stan=>{
          //   console.log("显示信息2段三段的")
          //   console.log(stan.stageName);
          //   if(stan.stageName =="一段" || stan.stageName =="二段" ){
          //     that.stageShow = false;
          //      that.tempGridList = [];
          //    that.base.GridGiftCount=0;
          //   }
          // })
        } else {
          if (data.ResponseMessage.ErrorMessage) {
            that.msg.Alert(data.ResponseMessage.ErrorMessage);
          } else {
            that.msg.Alert("该编码不存在！");
          }
        }
      }).catch(error => {
        console.log(error);
        loads.dismiss();
        that.msg.Alert(error.ResponseMessage.ErrorMessage);
      })
      loads.present();
    })
  }


  // 礼品弹窗
  async presentModal1() {
    let that = this;
    console.log("fnengnkrwngnkwnbgr");
    that.com.removeItem(["homing","product","meminfo"]);
    
    let ids:Array<string>=new Array<string>();
    // if(that.base.GridArrayData.length<=0){
    //   that.msg.Alert("请先操作【扫码销量】");
    //   return;
    // }
    that.base.GridArrayData.forEach(item => {
     
      console.log(item.id)
      ids.push(item.id);
      console.log("item.id--------------------------")
    });
   let checkitem:Array<any>=new Array<any>();
      that.tempGridList.forEach(temp=>{
        checkitem.push({"id":temp.id,"Name":temp.Name,"Code":temp.Code,"Num":temp.Num,"pid":temp.pid});
        // checkitem.push(temp.id);
        console.log("checkitem++++++++++++++++++")
        console.log(checkitem)
      });
    const modal = await that.modalCtrl.create({
      component: PublicselectionPage,
      componentProps: {
        "ids": ids,
        "checkItem":checkitem,
        "checked":that.ischeckAll,
        "typeItem": 1,
        "codetype":1

      }
    });
    await modal.present();
    // return await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data);
    that.lpArrayList=[];
    if(data.result.ResponseMessage.Success){
       let tempList:Array<any>=new Array<any>();
            tempList=data.result.Status;
            that.ischeckAll=data.checked;
      // let tempList:Array<any>=new Array<any>();
      // let resulttemp:Array<any>=new Array<any>();
      //   tempList=data.result.Status;
      //   resulttemp=that.tempGridList;
      //   if(tempList.length>0 ){
      //     if(that.tempGridList.length>0){
      //       tempList.forEach(item=>{
      //         if(that.tempGridList.findIndex(p=>p.id==item.id)==-1){
      //           resulttemp.push(item);
      //         }
      //       });
      //     }else{
      //       resulttemp=tempList;
      //     }
      //   }
        that.base.GridGiftCount=0;
        that.tempGridList=tempList;
        that.base.GridGiftCount=tempList.length;
        // that.tempGridList.forEach(item=>{
        //   if(that.lpArrayList.find(proc=>proc.id==item.id)){
        //     that.lpArrayList.find(proc=>proc.id==item.id).NewNum+=item.Num;
        //   }else{
        //     item.NewNum=item.Num;
        //     that.lpArrayList.push(item);
        //   }
        // });
    }
    console.log(data,"onWillDismiss");
  }
  /**
   * 样品选择弹窗
   */
  async seletionModal() {
    console.log("样品选择");
    let that = this;
    let ids:Array<string>=new Array<string>();
    if(that.base.GridArrayData.length<=0){
      that.msg.Alert("请先操作【扫码销量】");
      return;
    }
    that.base.GridArrayData.forEach(item => {
      ids.push(item.id);
    });
    let checkitem:Array<string> = new Array<string>();
    that.tempGridgifList.forEach(itemp =>{
      checkitem.push(itemp.id);

    })
    const modal = await that.modalCtrl.create({
      component: SelectionpagePage,
      componentProps: {
        'ids': ids,
        "checkItem":checkitem,
        "checked":that.ischeckAllg
      }
    });
    await modal.present();
    // return await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data);
    console.log(data,"onWillDismiss");
    if(data.result.ResponseMessage.Success){
      let tempgiftList:Array<any> = new Array<any>();
      tempgiftList = data.result.Status;
      that.ischeckAllg = data.checked;
      that.base.GridGiftNumber=0;
      that.tempGridgifList=tempgiftList;
      that.tempGridgifList.forEach(po=>{
        that.base.GridGiftNumber+=po.Num;
      });
    }
  }

  //删除商品或礼品
  deleteProduct(item,index)
  {
   let that=this;
  //  that.presentActionSheet(item,index);
  }  
   /**
   * 底部弹出删除
   */
  async presentActionSheet(itmid,index) {
    const that = this;
    console.log("itmiditmiditmiditmiditmiditmiditmid")
    console.log(itmid)
    const actionSheet = await this.actionSheetCtrl.create({
      // header: 'Albums',
      buttons: [{
        text: '删除',
        role: 'destructive',
        icon: 'trash',
        handler: () => {
          // 删除礼品
          if(that.tempGridList.length >0){
            // that.tempGridList = that.tempGridList.filter(item => item.id !== itmid);
            that.tempGridList.splice(index,1);
            if(that.com.GetStorageKey("homing")){
              localStorage.setItem("homing",JSON.stringify(that.tempGridList));
            }
            // that.tempGridList=that.tempGridList.splice( that.tempGridList.findIndex(item => item.id ==itmid), 1); 
          }
          that.base.GridGiftCount=that.tempGridList.length;
        }
      }, 
      {
        text: '取消',
        icon: 'close',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();
  }

/**
 * 
 *礼品删除
 */
presentActionSheetdel(item,index){
  const that = this;

  that.msg.Confirm("确定删除吗?","取消","确定").then(fit=>{
    if(fit){
      if(that.tempGridList.length >0){
        // that.tempGridList = that.tempGridList.filter(item => item.id !== itmid);
        that.tempGridList.splice(index,1);
        if(that.com.GetStorageKey("homing")){
          localStorage.setItem("homing",JSON.stringify(that.tempGridList));
        }
        // that.tempGridList=that.tempGridList.splice( that.tempGridList.findIndex(item => item.id ==itmid), 1); 
      }
      that.base.GridGiftCount=that.tempGridList.length;
    }
  });
}

  /**
   * 
   * 产品删除
   */
  presentActionGrids(itmid,index){
    const that = this;

    that.msg.Confirm("确定删除吗?","取消","确定").then(fit=>{
      if(fit){
        if(that.base.GridArrayData.length >0){
          // that.tempGridList = that.tempGridList.filter(item => item.id !== itmid);
          that.base.GridArrayData.splice(index,1);
          // that.tempGridList=that.tempGridList.splice( that.tempGridList.findIndex(item => item.id ==itmid), 1); 
        }
        that.base.GridListCount=that.base.GridArrayData.length;
        let isfalse:boolean = true;
        that.base.GridArrayData.filter(item =>{
            if(item.stageName == "一段" || item.stageName == "二段" ){
              isfalse = false;
            }
        });
        if(!isfalse){
          that.stageShow=false;
          that.base.GridGiftCount=0;
        }else{
          that.stageShow=true;
        }
      }
    });  
    }
   /**
   * 产品底部弹出删除
   */
  async presentActionGrid(itmid,index) {
    const that = this;
    console.log("itmiditmiditmiditmiditmiditmiditmid")
    console.log(itmid)
    const actionSheet = await this.actionSheetCtrl.create({
      // header: 'Albums',
      buttons: [{
        text: '删除',
        role: 'destructive',
        icon: 'trash',
        handler: () => {
          // 删除礼品
          if(that.base.GridArrayData.length >0){
            // that.tempGridList = that.tempGridList.filter(item => item.id !== itmid);
            that.base.GridArrayData.splice(index,1);
            // that.tempGridList=that.tempGridList.splice( that.tempGridList.findIndex(item => item.id ==itmid), 1); 
          }
          that.base.GridListCount=that.base.GridArrayData.length;
        }
      }, 
      {
        text: '取消',
        icon: 'close',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();
  }
 /**
  * 添加会员信息
  */
 addVipInfo(){
  this.presentAlertInputVIP();
 }

 async presentAlertInputVIP() {
  const that = this;
    console.log("绑定");
  //#region 判断订单是否当月订单
  //#endregion
  const alert = await this.alertController.create({
    header: '请输入手机号码',
    mode:"ios",
    inputs: [
      {
        name: 'phone',
        type: 'text',
        label: '请输入手机号码',
        value: '',
        min: 6
      }
    ],
    buttons: [
      {
        text: "确认",
        cssClass: 'btn-okay',
        handler: (Okay) => {
          //console.log(Okay,"ok");
        
          if (Okay && Okay["phone"]) {
            if(!(/^1[23456789]\d{9}$/.test(Okay["phone"]))){ 
              that.msg.Alert("手机号格式不正确").then(()=>{
                that.presentAlertInputVIP();
              });
            }else{
              let _obj = {};
              _obj["TelPhone"] = Okay["phone"];
              // that.addVipInfoHTTP(_obj);
              that.LoadVIPDataInfo(Okay["phone"]);
            }
          } else {
            that.msg.Alert("手机号不能为空").then(()=>{
              that.presentAlertInputVIP();
            });
          }
        }
      },
      {
        text: "取消",
        role: 'cancel',
        cssClass: 'secondary btn-cancel',
        handler: (cancel) => {
          //console.log(cancel,"cancel");
        }
      }
    ]
  });

  await alert.present();
}

LoadVIPDataInfo(PhoneNum:""){
  let that = this;
  // console.log("1008611");
  
  // console.log(that.element);
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let id = that.activaRouter.snapshot.paramMap.get('id');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  if (that.element.selectItemList.gridViewConfigName) {
    body.ConfigName = that.element.selectItemList.gridViewConfigName;
  }else{
    that.msg.Alert("服务端数据配置有误,请联系管理员");
    return;
  }
  body.ConfigName="TBMemberScanXML"; 
  body.OpType = "query";
  body.ConfigType = "view";
  body.RowsPerPage = app.RowsPerPage;
  body.PageNumber = 1;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = that.element.name;
  body.Client.ClientType = 2;
  if (that.platform.is("android")) {
    body.Client.ClientType = 0;
  } else if (that.platform.is("ios")) {
    body.Client.ClientType = 1;
  }
  body.RequestBody = {"b_TelPhone":PhoneNum};
  
  
  body.RequestBody = JSON.stringify(body.RequestBody);
  that.http.post(app.DEFAULTURL, body).then(data => {
    /****判断是否第一页begin****/
    console.log(10086);
    /****判断是否第一页end****/
    that.VipData={};
    if (data.ResponseMessage.Success) {
      if(data.Status&&data.Status.Datas.length>0)
      {
        that.VipData=data.Status;
      }
      console.log("会员信息",that.VipData);
      data.Status.Datas.forEach(function (item) {
        let objfield = {};
        let arrType=[];
        that.element.selectItemList.selectItem.forEach((element, index) => {
          if (element.bindingField) {
            objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
          }
          if(element.formatter && element.formatter == "Date"){
            if(objfield[element.bindingField].value){
              objfield[element.bindingField].value = objfield[element.bindingField].value.toString().replace(/-/g,"/");
            }
          }
        
          if(objfield["phone"] && objfield["phone"].value){
            objfield["phone"].value=that.com.PhoneNum(objfield["phone"].value);
          }
          if(objfield["name"] && objfield["name"].value){
            objfield["name"].value=that.com.FormatName(objfield["name"].value);
          }
          if(element.formatter && element.formatter == "type"){
            if(objfield[element.bindingField].value&&objfield[element.bindingField].value){
              if(objfield[element.bindingField]=="type2"||objfield[element.bindingField]=="type3"||objfield[element.bindingField]=="type4")
              {
                delete objfield[element.bindingField];
              }
            arrType.push(element.text);
            }
              // objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
          }
        
        });
        objfield["type1"] = { "value": arrType, "text": "新客标签"};
        that.arrayDataVip.push(objfield);
      });
      /****上拉加载数据begin****/
      
      /****上拉加载数据end****/
    }

  }).catch(error => {
    that.apiObj['status'] = false;
    that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
    that.loading = true;
    console.log(error);
  });
}
  


addVipInfoHTTP(obj){
  const that = this;
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let id = that.activaRouter.snapshot.paramMap.get('id');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  body.ConfigName = "ProductPurchaseRecordBindMember";
  body.OpType = "edite";
  body.ConfigType = "form";
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = that.element.name;
  body.Client.ClientType = 2;
  body.RequestBody = JSON.stringify(obj);
  return;
  that.msg.Loading("加载中，请稍后...").then(loads=>{
    that.http.post(app.DEFAULTURL, body).then(data => {
      loads.dismiss();
      if (data.ResponseMessage.Success) {
        that.msg.Alert("保存成功").then(()=>{
          that.LoadData(1);
        });
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      loads.dismiss();
      console.log(error);
      that.msg.Alert(error.ResponseMessage.ErrorMessage);
    });
    loads.present();
  });
}


}